import {INavigator, UserManager, UserManagerSettings} from "oidc-client-ts";


export default class MultiWindowUserManager extends UserManager {
    public constructor(settings: UserManagerSettings, redirectNavigator?: INavigator, popupNavigator?: INavigator, iframeNavigator?: INavigator) {
        super(settings, redirectNavigator, popupNavigator, iframeNavigator);

        window.addEventListener("storage", event => this._onLocalStorageChange(event), {passive: true});
    }

    private async _onLocalStorageChange(event: StorageEvent) {
        if (event.storageArea === localStorage) {
            if (event.key === "oidc." + this._userStoreKey) {
                let user = await this.getUser();
                if (user) {
                    await this._events.load(user);
                } else {
                    await this._events.unload();
                }
            }
        }
    }

}